import styled, { css } from 'styled-components';

export const FormattedDate = styled.div`
  font-size: 14px;
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  overflow: hidden;
  display: flex;
  align-items: center;

  ${(props: { $dateState: '<2weeks' | '>2weeks' | '>3weeks' }) => {
    if (props.$dateState === '>3weeks') {
      return css`
        color: #d14343;
      `;
    }
    if (props.$dateState === '>2weeks') {
      return css`
        color: #ff9900;
      `;
    }
    return css`
      color: #474d66;
    `;
  }}
`;
